module.exports = __webpack_public_path__ + "static/media/1.6fd43468.png";